import _ from "lodash";

function gaSelectItem(info) {
  const newItem = {
    item_id: info.item.id,
    item_name: info.item.product,
    item_brand: info.item.dimension,
    item_category: info.item.quantity_unit,
    price: _.sumBy(info.item.invoices, function (invoice) {
      return _.toNumber(invoice.unit_price);
    }),
    quantity: _.toNumber(info.item.quantity),
  };
  window.gtag("event", "select_item", {
    env: process.env.NODE_ENV,
    item_list_id: info.item_list_id,
    item_list_name: info.item_list_name,
    items: [newItem],
  });
}

function gaViewItem(info) {
  const newItem = {
    item_id: info.item.id,
    item_name: info.item.product,
    item_brand: info.item.dimension,
    item_category: info.item.quantity_unit,
    price: _.sumBy(info.item.invoices, function (invoice) {
      return _.toNumber(invoice.unit_price);
    }),
    quantity: _.toNumber(info.item.quantity),
  };
  window.gtag("event", "view_item", {
    env: process.env.NODE_ENV,
    currency: "USD",
    value: info.price,
    items: [newItem],
  });
}

function gaAddToCart(info) {
  const newItem = {
    item_id: info.item.id,
    item_name: info.item.product,
    item_brand: info.item.dimension,
    item_category: info.item.quantity_unit,
    price: _.sumBy(info.item.invoices, function (invoice) {
      return _.toNumber(invoice.unit_price);
    }),
    quantity: _.toNumber(info.item.quantity),
  };
  window.gtag("event", "add_to_cart", {
    env: process.env.NODE_ENV,
    currency: "USD",
    value: info.price,
    items: [newItem],
  });
}

function gaViewCart(info) {
  const mappedItems = [];
  _.map(info.items, function (item) {
    const newItem = {
      item_id: item.id,
      item_name: item.product,
      item_brand: item.dimension,
      item_category: item.quantity_unit,
      price: _.sumBy(item.invoices, function (invoice) {
        return _.toNumber(invoice.unit_price);
      }),
      quantity: _.toNumber(item.quantity),
    };
    mappedItems.push(newItem);
  });
  window.gtag("event", "view_cart", {
    env: process.env.NODE_ENV,
    currency: "USD",
    value: info.subtotal,
    items: mappedItems,
  });
}

function gaRemoveFromCart(info) {
  const newItem = {
    item_id: info.id,
    item_name: info.product,
    item_brand: info.dimension,
    item_category: info.quantity_unit,
    price: _.sumBy(info.invoices, function (invoice) {
      return _.toNumber(invoice.unit_price);
    }),
    quantity: _.toNumber(info.quantity),
  };
  window.gtag("event", "remove_from_cart", {
    env: process.env.NODE_ENV,
    currency: "USD",
    value: _.sumBy(info.invoices, function (invoice) {
      return _.toNumber(invoice.unit_price);
    }),
    items: [newItem],
  });
}

function gaBeginCheckout(info) {
  const mappedItems = [];
  _.map(info.items, function (item) {
    const newItem = {
      item_id: item.id,
      item_name: item.product,
      item_brand: item.dimension,
      item_category: item.quantity_unit,
      price: _.sumBy(item.invoices, function (invoice) {
        return _.toNumber(invoice.unit_price);
      }),
      quantity: _.toNumber(item.quantity),
    };
    mappedItems.push(newItem);
  });
  window.gtag("event", "begin_checkout", {
    env: process.env.NODE_ENV,
    currency: "USD",
    value: info.total,
    items: mappedItems,
  });
}

function gaPurchase(info) {
  const mappedItems = [];
  _.map(info.items, function (item) {
    const newItem = {
      item_id: item.id,
      item_name: item.product,
      item_brand: item.dimension,
      item_category: item.quantity_unit,
      price: _.sumBy(item.invoices, function (invoice) {
        return _.toNumber(invoice.unit_price);
      }),
      quantity: _.toNumber(item.quantity),
    };
    mappedItems.push(newItem);
  });
  window.gtag("event", "purchase", {
    env: process.env.NODE_ENV,
    transaction_id: info.transaction_id,
    tax: info.tax,
    shipping: info.shipping,
    currency: "USD",
    value: info.total,
    items: mappedItems,
  });
}

const gaFunctions = {
  gaSelectItem: gaSelectItem,
  gaViewItem: gaViewItem,
  gaAddToCart: gaAddToCart,
  gaViewCart: gaViewCart,
  gaRemoveFromCart: gaRemoveFromCart,
  gaBeginCheckout: gaBeginCheckout,
  gaPurchase: gaPurchase,
};

export default gaFunctions;
